export const eq = <TDataItem, TKey extends keyof TDataItem>(
  key: TKey,
  value: TDataItem[TKey]
) => (dataItem: TDataItem) => value === dataItem[key];

export const notEq = <TDataItem, TKey extends keyof TDataItem>(
  key: TKey,
  value: TDataItem[TKey]
) => (dataItem: TDataItem) => value !== dataItem[key];
